// Searchable Malayalam font selector with live preview.
import React, { useMemo, useState } from "react";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { ChevronDown, Search } from "lucide-react";
import { MALAYALAM_FONTS, PREVIEW_TEXT, loadFontPreview } from "@/lib/charterFonts";

export default function FontSelector({ value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = useMemo(
    () => MALAYALAM_FONTS.filter(f => f.family.toLowerCase().includes(q.toLowerCase())),
    [q]
  );
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full justify-between bg-white" data-testid={testid}>
          <span style={{ fontFamily: `'${value}', sans-serif` }}>{value}</span>
          <ChevronDown className="w-4 h-4 text-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-2" align="start">
        <div className="relative mb-2">
          <Search className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Search Malayalam font…" className="pl-8 h-9" data-testid={`${testid}-search`} />
        </div>
        <div className="max-h-72 overflow-y-auto space-y-1" data-testid={`${testid}-list`}>
          {list.map(f => (
            <button key={f.family} type="button"
              className={`w-full text-left rounded-md border p-2.5 transition-colors ${value === f.family ? "border-emerald-700 bg-emerald-700/5" : "border-transparent hover:bg-muted/60"}`}
              onMouseEnter={() => loadFontPreview(f.family)}
              onClick={() => { loadFontPreview(f.family); onChange(f.family); setOpen(false); }}
              data-testid={`${testid}-option-${f.family.replace(/\s+/g, "-")}`}>
              <div className="text-xs font-semibold text-muted-foreground">{f.family} <span className="font-normal">({f.weights.join("/")})</span></div>
              <div className="text-lg leading-snug" style={{ fontFamily: `'${f.family}', sans-serif` }}>{PREVIEW_TEXT}</div>
            </button>
          ))}
          {!list.length && <div className="text-sm text-muted-foreground text-center py-4">No matching Malayalam font</div>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
